<div class="p-col p-field">
  <label for="name">{{'component.reports.detail.name_new_report' | translate}}</label>
    <input name="name" type="text" pInputText [(ngModel)]="report.name" />
</div>
<button pButton class="p-ml-3" style="float: right;" (click)="cloneReport()"><i class="fa fa-copy"></i> &nbsp;{{'component.reports.detail.duplicate_report' | translate}}</button>
<button pButton class="p-button-secondary" style="float: right;" (click)="cancel()">{{'general.action.cancel' | translate}}</button>
